import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { useDevis } from '../context/DevisContext';

const Pagination = () => {
  const {
    currentPage,
    totalPages,
    filteredQuotes,
    // itemsPerPage,
    paginate,
    renderPaginationNumbers
  } = useDevis();

  if (filteredQuotes.length === 0) {
    return null;
  }

  return (
    <div className="mt-6 flex flex-col sm:flex-row justify-between items-center">
      <div className="mb-4 sm:mb-0 text-sm text-gray-600">
        Page {currentPage} sur {totalPages} ({filteredQuotes.length} devis au total)
      </div>

      <div className="flex items-center space-x-1">
        <button
          onClick={() => paginate(1)}
          disabled={currentPage === 1}
          className="px-2 py-1 border rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Première page"
        >
          <ChevronsLeft className="w-4 h-4" />
        </button>

        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-2 py-1 border rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Page précédente"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>

        {renderPaginationNumbers().map((page, index) =>
          page === "..." ? (
            <span key={`ellipsis-${index}`} className="px-3 py-1">
              ...
            </span>
          ) : (
            <button
              key={`page-${page}`}
              onClick={() => paginate(page)}
              className={`px-3 py-1 border rounded-md transition-colors ${
                currentPage === page
                  ? "bg-indigo-600 text-white font-medium"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              {page}
            </button>
          )
        )}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-2 py-1 border rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Page suivante"
        >
          <ChevronRight className="w-4 h-4" />
        </button>

        <button
          onClick={() => paginate(totalPages)}
          disabled={currentPage === totalPages}
          className="px-2 py-1 border rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Dernière page"
        >
          <ChevronsRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;